"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  sentenceLength: {
    recommendedWordCount: 20,
    slightlyTooMany: 25,
    farTooMany: 30
  },
  fleschReading: {
    borders: {
      veryEasy: 90,
      easy: 80,
      fairlyEasy: 70,
      okay: 60,
      fairlyDifficult: 50,
      difficult: 30,
      veryDifficult: 0
    },
    scores: {
      veryEasy: 9,
      easy: 9,
      fairlyEasy: 9,
      okay: 9,
      fairlyDifficult: 6,
      difficult: 3,
      veryDifficult: 3
    }
  }
};